module.exports = __webpack_public_path__ + "img/wallet.9f5def02.png";